<div class="p-6">
  <div
    class="relative -ml-6 -mr-6 -mt-6 flex h-14 items-center justify-center gap-2 border-b border-grey-7 border-b-grey-8"
  >
    <div
      class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-apricot-2"
    >
      <app-ui-icon color="var(--white)" name="star_filled" size="sm"></app-ui-icon>
    </div>
    <h2 class="font-bold">{{ customerName }} har fått ett nytt omdöme!</h2>
    <button
      (click)="closeDialog()"
      class="icon-button absolute top-1 right-1"
      type="button"
    >
      <app-ui-icon
        class="close-icon"
        color="var(--grey-1)"
        name="close"
      ></app-ui-icon>
    </button>
  </div>

  <div class="mb-6">
    <h3 class="my-4 text-lg font-bold">Läs och besvara omdömet nedan</h3>
    <p class="mt-4 text-lg">
      Genom att besvara omdömet får patienter en bättre uppfattning om er som
      vårdgivare.
    </p>

    <div *ngIf="review !== null" class="customer-rating-container">
      <div class="user-comment">
        <div class="row">
          <div class="user-comment-details col">
            <p class="user-comment-date italic">
              {{ formatDate(review.dateCreated) }}
              <b>{{ review.author }}</b> skrev:
            </p>
            <p class="text-base">
              {{ review.comment }}
            </p>
          </div>
        </div>
        <div class="user-single-user-rating col-s mt-6">
          <div
            *ngFor="
              let ratingAnswer of review.reviewAnswers;
              trackBy: trackByMethodAnswers
            "
            class="rating-line"
          >
            <span>{{ ratingAnswer.reviewQuestion.name }}</span>
            <app-star-rating
              [label]="ratingAnswer.reviewQuestion.name"
              [rate]="ratingAnswer.rating"
            ></app-star-rating>
          </div>
        </div>
      </div>
    </div>

    <form [formGroup]="userDataForm">
      <div class="row">
        <div class="col">
          <p>
            <small><b>Skriv ditt svar här</b></small>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field
            class="full-width"
            hintLabel="Max. {{ maxCommentLength }} tecken"
          >
            <textarea
              #kommentar
              [maxLength]="maxCommentLength"
              formControlName="comment"
              matInput
              placeholder="Ditt svar"
            ></textarea>
            <mat-hint align="end"
            >{{ kommentar.value?.length || 0 }}/{{
                maxCommentLength
              }}
            </mat-hint
            >
            <mat-error
              *ngIf="userDataForm.controls.comment.hasError('required')"
            >
              Ditt svar <strong>krävs</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>

    <div *ngIf="formHasError">
      <mat-error> Fyll i alla obligatoriska fält</mat-error>
    </div>

  </div>
  <div class="modal-actions flex flex-col gap-2 md:flex-row" mat-dialog-actions>
    <app-ui-button (click)="saveRating()" color="green" expanded="block"
    >Publicera svar
    </app-ui-button
    >
    <app-ui-button (click)="closeDialog()" color="ghost" expanded="block"
    >Stäng
    </app-ui-button
    >
  </div>
</div>
